"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _proptypes = require("../utils/proptypes");

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

var _uid = require("../utils/uid");

var _events = require("./events");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Modal =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Modal, _Component);

  function Modal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.id = (0, _uid.getUidStr)();
    _this.visible = props.visible;
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.visible && !this.props.usePortal) {
      (0, _events.open)(this.getOption(), false);
    }
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if ((0, _shallowEqual.default)(this.props, nextProps)) return false;
    if (nextProps.visible) return true;
    (0, _events.close)({
      id: this.id
    });
    return !(0, _shallowEqual.default)(this.props, nextProps) && nextProps.visible;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && !this.props.usePortal) {
      (0, _events.open)(this.getOption(), false);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    (0, _events.close)({
      id: this.id
    });
    (0, _events.destroy)(this.id);
  };

  _proto.getOption = function getOption() {
    var _this$props = this.props,
        children = _this$props.children,
        usePortal = _this$props.usePortal,
        visible = _this$props.visible,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "usePortal", "visible"]);

    return _objectSpread({}, props, {
      content: children,
      id: this.id
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        usePortal = _this$props2.usePortal,
        visible = _this$props2.visible;
    var option = this.getOption();
    if (visible && usePortal) return (0, _events.open)(option, true);
    return null;
  };

  return Modal;
}(_react.Component);

Modal.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  usePortal: _propTypes.default.bool
});
Modal.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  usePortal: true,
  visible: false
});
Modal.displayName = 'ShineoutModal';
var _default = Modal;
exports.default = _default;